<template>
<div class="certificate">
<div style="min-height: calc(100% - 220px);box-sizing: border-box;">
  <div class="assessTit">
    <div class="commonW" style="padding-top:16px;">
      <div class="left">
        <img src="../assets/wangLG.png" />
      </div>
     <div class="right"><span><img src="../assets/tel.png" /></span>  400-777-5999</div>
    </div>
  </div>
 <div class="commonW">
  <!-- 在线获取线下平台证书 -->
  <div class="step01">
    <div class="title">在线获取线下平台证书</div>
    <el-form  :model="searchForm" :rules="searchRules" ref="searchForm" label-position="left" label-width="0px">
      <el-form-item prop="projectId">
        <el-input type="text" style="border:0px;" v-model.trim="searchForm.projectId" auto-complete="off" name="textfield" placeholder="请输入项目编号" :maxlength="8"></el-input>
      </el-form-item>
      <div class="question" @click="toQuestions('1')">如何查看找到项目编号？</div>
      <el-form-item prop="securityCode">
          <el-input type="text" v-model.trim="searchForm.securityCode" auto-complete="off" name="textfield" placeholder="请输入安全码" :maxlength="8"></el-input>
      </el-form-item>
      <div class="question" @click="toQuestions('1')">如何查看找到安全码？</div>
      <el-form-item prop="validCode">
        <el-input type="text" v-model.trim="searchForm.validCode" auto-complete="off" placeholder="验证码" :maxlength="4"
                  style="width: 80%;"></el-input>
        <a class="code" href="javascript:;" style="font-size:20px;margin-left:30px;">
          <em class="code-data" @click="getValidCode">{{codedata}}</em>
        </a>
      </el-form-item>
      <div style="width:680px;text-align:center;margin-top:80px;">
        <el-button type="primary" style="width:200px;" @click.native.prevent="searchSubmit" :loading="searching">查询
        </el-button>
      </div>
    </el-form>
  </div>
  </div>
  </div>
  <div class="footer clear-fix" style="min-width:1100px;margin-top:20px;">
    <div style="max-width:1100px;margin:0 auto;">
      <div class="aboutUs">
        <div class="title">关于我们</div>
        <div><a style="color: #C0C0C0;" target="_blank" href="http://www.itlong.com.cn/about.html" rel="noopener noreferrer">企业介绍</a></div>
        <div><a style="color: #C0C0C0;" target="_blank" href="http://www.itlong.com.cn/qiyewenhua.html" rel="noopener noreferrer">企业文化</a></div>
        <div><a style="color: #C0C0C0;" target="_blank" href="http://www.itlong.com.cn/zizhirongyu.html" rel="noopener noreferrer">资质荣誉</a></div>
        <div><a style="color: #C0C0C0;" target="_blank" href="http://www.itlong.com.cn/hezuohuoban73.html" rel="noopener noreferrer">合作伙伴</a></div>
        <div><a style="color: #C0C0C0;" target="_blank" href="http://www.itlong.com.cn/pinpaiziyuan.html" rel="noopener noreferrer">品牌资源</a></div>
      </div>
      <div class="footerBor footerBor1"></div>
      <div class="concatUs">
        <div class="title">联系我们</div>
        <div>总　　机　0755-86675999 </div>
        <div>销售邮箱　shangwu@itlong.com.cn</div>
        <div>售后邮箱　fw@itlong.com.cn</div>
        <div>总部地址　深圳市南山区学苑大道1001号南山智园C1栋12楼</div>
        <div>邮　　编　518055   </div>
      </div>
      <div class="footerBor footerBor2"></div>
      <div class="company">
        <div>Copyright © 1997-2021 版权所有:深圳市旺龙智能科技有限公司</div>
        <div>粤ICP备18085992号</div>
        <div>旺龙智能-为您提供智能云梯控，云门禁，云对讲报价、价格、采购，智能云梯控、云门禁、云对讲品牌商，厂家，供应商，批发商！</div>
      </div>
    </div>
  </div>
 </div>
</template>
<script>
import QrCode from 'qrcode-decoder'
  export default {
    data() {
      var checkProject = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('请输入8位项目编号'));
        }
        var reg = new RegExp("^[0-9]{8}$", "ig");
        if (!reg.test(value)) {
          return callback(new Error('请输入正确的项目编号'));
        }
        callback();
      };
      var checkSecurityCode = (rule, value, callback) => {
        console.log(value)
        if (!value) {
          return callback(new Error('请输入8位安全码'));
        }
        var reg = new RegExp("^[0-9A-Za-z]{8}$", "ig");
        if (!reg.test(value)) {
          return callback(new Error('请输入正确的安全码'));
        }
        callback();
      };
    
      return {
        searchForm:{
          projectId:'',
          securityCode:'',
          validCode:'',
        },
        searching:false,
        searchRules:{
          projectId: [
            {required: true, validator:checkProject, trigger: 'blur'},
          ],
          securityCode: [
            {required: true, validator:checkSecurityCode, trigger: 'blur'},
          ],
          validCode: [
            {required: true, validator: this.$util.checkEmojiNotNull('请输入验证码'), trigger: 'blur'},
          ]
        },
        codedata:'',
      };
    },
    methods: {
      getValidCode() {
        var $chars = 'ABCDEFGHJKMNPQRSTWXYZgabcdefhijkmnprstwxyz1234567890';
        var maxPos = $chars.length;
        var code = '';
        for (var i = 0; i < 4; i++) {
          code += $chars.charAt(Math.floor(Math.random() * maxPos));
        }
        this.codedata = code;
      },
      checkValidCode() {
        if (this.codedata.toLowerCase() != this.searchForm.validCode.toLowerCase()) {
          this.$message({
            message: "验证码填写错误",
            type: 'error'
          });
          this.resetValidCode();
          return false;
        }
        return true;
      },
      //在线查询
      searchSubmit(){
        if (this.searching) {
          return;
        }
        this.searching = true;
        this.$refs.searchForm.validate((valid) => {
          if (!valid) {
            this.searching = false;
            return;
          }
          if (!this.checkValidCode()) {
            return;
          }
          var params = {
            projectId: this.searchForm.projectId,
            securityCode: this.searchForm.securityCode,
            operateFunction:'证书网站',
            operateWay:'在线查询证书',
          };
          this.$api.getLicense(params).then((res) => {
            if (this.$util.checkCode(this, res)) {
              window.sessionStorage.setItem('securityInfo',JSON.stringify(res.data))
              this.$router.push({path: '/downLoad',query: {projectId: window.btoa(this.searchForm.projectId),securityCode: window.btoa(this.searchForm.securityCode)}});
            }
            this.resetValidCode();
          }).catch((err) => {
            this.resetValidCode();
            this.$util.showCatchErr(this, err, "查询证书信息失败");
          });
        });
      },
      resetValidCode() {
        this.searching = false;
        this.getValidCode();
      },
      
      toQuestions(val){
        window.open('/question?activeName='+window.btoa(val), "_blank");
      },
    },
    mounted(){
　　　 this.getValidCode()
      
    },
  }
</script>
<style scoped>
  .certificate{
    height:100%;
    background:#fff;
    overflow:hidden; 
    overflow-y:auto;
    min-width:1100px;
    max-width:100%;
  }
  .commonW{
    min-width:1100px;
    max-width:1100px;
    margin:0 auto;
  }
  .el-table-add-row {
    width:85%;float:right;
    height: 34px;
    border: 1px dashed #c1c1cd;
    border-radius: 3px;
    cursor: pointer;
    justify-content: center;
    display: flex;
    line-height: 34px;
  }
  /* 弹框样式 */
  .myToast {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999999;
    width: 100%;
    height: 100%;
    display: flex;    
    display: -webkit-flex; /* Safari */
    -webkit-align-items: center; /* Safari 7.0+ */
    align-items: center;
    justify-content: center;
    -webkit-justify-content: center; /* Safari 6.1+ */
  }
  .myToast .error{
    max-width: 300px;
    min-width: 100px;
    background: rgba(0, 0, 0, 0.8);
    padding: 8px 15px;
    text-align: center;
    color: white;
    font-size: 16px;
    border-radius: 5px;
  }
  .assessTit{
    width:100%;
    height:80px;
    margin-bottom:50px;
    background:rgba(255,255,255,1);
    border-bottom:1px solid rgba(190,190,190,1);
  }
  .assessTit img{
    width:250px;
    margin-top:8px;
  }
  .assessTit .left{
    float: left;
  }
  .assessTit .left span{
    display:inline-block;width:1px; height:26px;background:rgba(197,197,197,1);margin:0 10px;
  }
  .assessTit .font{
    font-size: 26px;
    color: #2E2E2E;
    letter-spacing:8px;
    margin-top:8px;
  }
  .assessTit .right{
    float: right;
    font-size: 20px;
    color:#2E2E2E;
  }
  .assessTit .right span{
    display: inline-block;
    width:40px;
    height:40px;
    background:rgba(255,255,255,1);
    border:1px solid #BEBEBE;
    border-radius:50%;
    text-align: center;
  }
  .assessTit .right img{
    width:16px;
    margin-top:12px;
  }
  .step01{
    max-width:680px;
    margin:0 auto;
  }
  .step02{
    margin-top:20px;
  }
  .step02 .tips{
    padding-left:45px;
  }
  .step01  .title,.step02  .title{
    width:100%;
    text-align: center;
    font-size: 28px;
    margin-bottom:40px;
  }
  .step01 .question,.step02 .question{
    margin-bottom: 20px;
    cursor: pointer;
  }
  .step02 .question{
    margin-left: 113px;
  }
  .step02 .box-card{
    padding:30px;
    margin-bottom: 30px;
  }
  .tipBox{
    display: inline-block;
    width:200px;
    height:50px;
    line-height:50px;
    text-align:center;
    border-radius:30px;
    border:1px dashed #1518b8;
    background: #fff;
    position: relative;
    top: -73px;
    left: 567px;
  }
  .tipBox div{
    width:180px;
    border-bottom:1px dashed #1518b8;
    position: absolute;
    left:-180px;
    top:25px;
  }
  .securityInfo{
    display:inline-block;
    vertical-align: top;
    margin-left:50px;
    width:500px;
  }
  .box-card .info{
    height: auto;
    margin-bottom:22px;
  }
  .textBreak{
        text-align:justify;
        word-break:break-all;
        overflow: hidden;
  }
  .gree{color:#67C23A;}
  .red{color: #de0f0f;}
  
  .footer{
    min-width:1100px;
    max-width:100%;
    height:200px;
    background: #31373A;
    z-index: 99999;
    margin-top:20px;
    padding-top:30px;
    box-sizing: border-box;
    color: #C0C0C0;
  }
  .footer .aboutUs,.footer .concatUs,.footer .company{
    float: left;
  }
  .footer .aboutUs div,.footer .concatUs div,.footer .company div{
    margin-bottom:5px;
  }
  .footer .title{
    color:#fff;margin-bottom:15px!important;
  }
  .footer .aboutUs{
    width: 60px;
  }
  .footer .concatUs{
    width: 380px;
  }
  .footer .company{
    width: calc(100% - 600px);
    margin-top:30px;
  }
  .footer .footerBor{
    float: left;
    width: 1px;
    height: 130px;
    background: #616161;
    margin:0 39px;
    margin-top:20px;
  }
  /*清除浮动*/
.clear-fix::after {
  content: ".";    
  display: block;  
  clear: both;     
  visibility: hidden;      
  height: 0;   
  font-size:0;    
}
.spanBtn{
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #FFF;
    border: 1px solid #DCDFE6;
    color: #606266;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    -webkit-transition: .1s;
    transition: .1s;
    font-weight: 500;
    padding: 12px 20px;
    font-size: 14px;
    border-radius: 4px;
}
.spanBtn.primary{
    color: #FFF;
    background-color: #409EFF;
    border-color: #409EFF;
}
.el-collapse{
  border:none;
}
.itemlabel{
  display: inline-block;
  color:#333;
  font-size: 18px;
}
</style>
<style>
 
  a{
    text-decoration:none;
  }
  .step01 .el-input__inner{
    border: none;
    border-bottom: 1px solid #DCDFE6;
    border-radius: 0;
  }
  .step02 .el-table th{
    padding: 4px 0;
  }
  .stepQues .el-collapse-item__header,.stepQues .el-collapse-item__wrap{
    border: none;
  }
  .stepQues .el-collapse-item__header{
    font-size: 16px;
  }
  .stepQues .el-collapse-item__content{
    background: #f3f3f3;
    padding:20px 15px;
    padding-bottom:40px;
    color: #606266;
  }
  html,body{
    height: auto;
  }
</style>


// WEBPACK FOOTER //
// Main.vue?57bb166a